import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaPhone,
  FaMapMarkerAlt,
  FaGlobe
} from "react-icons/fa";

const FooterLogin = ({ colorFondo = "#1e40af" }) => {
  return (
    <footer className="footer-login" style={{ ...styles.footer, background: colorFondo }}>
      {/* Línea de separación arriba — para cuando el fondo de la página
          y el del footer son del mismo color y si no, no se nota dónde
          termina una cosa y empieza la otra */}
      <div className="footer-divider-top" style={styles.dividerTop}></div>

      <div style={styles.container}>

        {/* Logo y descripción */}
        <div style={styles.logoSection}>
          <img src="/logo.png" alt="DSM Logo" style={styles.logo} />

          <h3 style={styles.school}>
            Deutsche Schule Managua
          </h3>

          <p style={styles.desc}>
            Sistema oficial de reservas de citas entre padres y docentes
            de la Deutsche Schule Managua.
          </p>
        </div>

        {/* Información */}
        <div style={styles.col}>
          <h4 style={styles.title}>Información</h4>

          <div style={styles.line}>
            <FaGlobe style={styles.icon} />
            <a
              href="https://dsm.edu.ni"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              dsm.edu.ni
            </a>
          </div>

          <div style={styles.line}>
            <FaPhone style={styles.icon} />
            <span>+505 2298 1000</span>
          </div>

          <div style={styles.line}>
            <FaMapMarkerAlt style={styles.icon} />
            <span>
              Carretera Sur Km 10 ½  
              Managua, Nicaragua
            </span>
          </div>

          {/* Redes */}
          <div style={styles.social}>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noreferrer"
              style={styles.socialBtn}
            >
              <FaFacebook />
            </a>

            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noreferrer"
              style={styles.socialBtn}
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Mapa */}
        <div style={styles.mapContainer}>
          <h4 style={styles.title}>Ubicación</h4>

          <iframe
            title="DSM ubicación"
            src="https://www.google.com/maps?q=Deutsche+Schule+Managua&output=embed"
            style={styles.map}
            loading="lazy"
          ></iframe>
        </div>

      </div>

      {/* Línea */}
      <div className="footer-divider" style={styles.divider}></div>

      {/* Copyright */}
      <div style={styles.copy}>
        Sistema de Citas DSM · Derechos Reservados (Haru) © 2026
      </div>

      <style>
        {`
          @media (max-width: 640px) {
            .footer-login {
              padding: 24px 16px 14px !important;
            }
            .footer-login > div:first-child {
              gap: 20px !important;
            }
            .footer-login img {
              height: 40px !important;
              margin-bottom: 6px !important;
            }
            .footer-login h3 {
              font-size: 17px !important;
            }
            .footer-login iframe {
              height: 110px !important;
            }
            .footer-login .footer-divider {
              margin: 16px 0 10px !important;
            }
          }
        `}
      </style>
    </footer>
  );
};

export default FooterLogin;

const styles = {

  footer: {
    color: "white",
    padding: "34px 20px 16px"
  },

  container: {
    maxWidth: "1200px",
    margin: "auto",
    display: "flex",
    flexWrap: "wrap",
    gap: "28px",
    justifyContent: "space-between"
  },

  logoSection: {
    maxWidth: "260px"
  },

  logo: {
    height: "42px",
    marginBottom: "8px"
  },

  school: {
    fontSize: "17px",
    fontWeight: "700",
    marginBottom: "5px"
  },

  desc: {
    fontSize: "13px",
    opacity: 0.9
  },

  col: {
    minWidth: "220px"
  },

  title: {
    fontSize: "14px",
    fontWeight: "700",
    marginBottom: "9px"
  },

  line: {
    display: "flex",
    gap: "8px",
    marginBottom: "6px",
    fontSize: "13px",
    alignItems: "flex-start"
  },

  icon: {
    marginTop: "3px",
    color: "#93c5fd"
  },

  link: {
    color: "white",
    textDecoration: "none"
  },

  social: {
    display: "flex",
    gap: "12px",
    marginTop: "14px"
  },

  socialBtn: {
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    background: "rgba(255,255,255,0.15)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    color: "white",
    transition: "all 0.3s ease"
  },

  mapContainer: {
    minWidth: "260px"
  },

  map: {
    width: "100%",
    height: "130px",
    border: "none",
    borderRadius: "10px"
  },

  divider: {
    height: "1px",
    background: "rgba(255,255,255,0.2)",
    margin: "20px 0 12px"
  },

  dividerTop: {
    height: "1px",
    background: "rgba(255,255,255,0.35)",
    marginBottom: "24px"
  },

  copy: {
    textAlign: "center",
    fontSize: "12px",
    opacity: 0.8
  }

};